import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useImmer } from "use-immer";
import { notification, Rate, Spin } from "antd";
import { editReviewApi, getReviewApi } from "@services/review.api";
import { Card } from "@components/Card";
import { Button } from "@components/Button";
import { Textarea } from "@components/Textarea";
import cs from "./EditReviewPage.module.scss";

export const EditReviewPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [review, setReview] = useImmer({ rating: 0, comment: "" });

  const params = useParams();
  const reviewId = params.reviewId as string;

  const navigate = useNavigate();

  useEffect(() => {
    if (params.reviewId) {
      getReviewApi(reviewId)
        .then((response) => {
          if (response.isSuccess) {
            setReview(response.data);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [params]);

  return (
    <main className="AddReviewPage">
      <header className="mb75">
        <h1 className="h3">Wystaw opinię</h1>
      </header>

      <section>
        <Spin spinning={isLoading}>
          <Card className={cs.card}>
            <Card.Header className="h4 text-center">
              Jak przebiegła współpraca z firmą {review.target_company_name}?
            </Card.Header>

            <Card.Body>
              <div className="mb16">
                <div>
                  <label>Ocena</label>
                </div>
                <Rate
                  value={review.main_rating}
                  allowHalf
                  onChange={(newVal) => {
                    setReview((review) => {
                      review.main_rating = newVal;
                    });
                  }}
                />
              </div>

              <Textarea
                value={review.comment}
                label="Komentarz"
                placeholder="Podziel się opinią na temat współpracy z tą firmą"
                rows={4}
                maxLength={1000}
                size="large"
                onChange={(newVal) => {
                  setReview((review) => {
                    review.comment = newVal;
                  });
                }}
              />
            </Card.Body>

            <Card.Footer>
              <Button type="primary" size="large" onClick={handleSubmit}>
                Zapisz opinię
              </Button>
            </Card.Footer>
          </Card>
        </Spin>
      </section>
    </main>
  );

  async function handleSubmit() {
    setIsLoading(true);

    const response = await editReviewApi(review);

    if (response.isSuccess) {
      notification.success({
        message: "Opinia została zaktualizowana. Dziękujemy!",
        placement: "topRight",
        duration: 4,
      });

      navigate("/");
    } else {
      notification.error({
        message: "Wystąpił błąd.",
        description: "Spróbuj ponownie za jakiś czas.",
        placement: "topRight",
      });

      setIsLoading(false);
    }
  }
};
